export default __webpack_public_path__ + "static/media/slider4.00121753.jpg";